import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[ErrorBoundary]', error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null, info: null });
    }
  }

  handleReload = () => window.location.reload();
  handleReset  = () => this.setState({ error: null, info: null });

  render() {
    if (!this.state.error) return this.props.children;

    const isDev = process.env.NODE_ENV === 'development';

    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}>
        <div style={{
          maxWidth: 480,
          width: '100%',
          background: 'var(--surface-card)',
          border: '1px solid var(--border-default)',
          borderRadius: 12,
          padding: '32px 28px',
          textAlign: 'center',
          boxShadow: 'var(--shadow-md)',
        }}>
          <div style={{
            width: 56, height: 56,
            margin: '0 auto 18px',
            borderRadius: '50%',
            background: 'rgba(217,74,74,0.10)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <AlertTriangle size={28} style={{ color: 'var(--state-danger)' }} />
          </div>

          <h2 style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 18, fontWeight: 700,
            color: 'var(--brand-ink)', marginBottom: 8,
            letterSpacing: '-0.01em',
          }}>
            Algo salió mal
          </h2>

          <p style={{
            color: 'var(--brand-muted)', fontSize: 13,
            lineHeight: 1.5, marginBottom: 22,
          }}>
            Ocurrió un error inesperado al cargar esta sección. Puedes intentar
            recargar la página o volver a la sección anterior.
          </p>

          {isDev && (
            <details style={{
              textAlign: 'left',
              background: 'rgba(217,74,74,0.05)',
              border: '1px solid rgba(217,74,74,0.18)',
              borderRadius: 6,
              padding: '10px 12px',
              marginBottom: 18,
              fontSize: 11,
            }}>
              <summary style={{ cursor: 'pointer', color: 'var(--state-danger)', fontWeight: 600 }}>
                Detalles del error (solo dev)
              </summary>
              <pre style={{
                fontFamily: 'monospace',
                fontSize: 11,
                color: 'var(--text-secondary)',
                marginTop: 8,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: 240,
                overflow: 'auto',
              }}>
                {this.state.error.toString()}
                {this.state.info?.componentStack}
              </pre>
            </details>
          )}

          <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
            <button onClick={this.handleReload} style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '9px 18px',
              background: 'var(--brand-primary)',
              border: 'none', borderRadius: 8,
              color: '#fff', fontSize: 13, fontWeight: 600,
              cursor: 'pointer',
              transition: 'background 0.15s',
            }}>
              <RefreshCw size={14} /> Recargar
            </button>
            <button onClick={this.handleReset} style={{
              padding: '9px 18px',
              background: 'transparent',
              border: '1px solid var(--border-default)',
              borderRadius: 8,
              color: 'var(--brand-muted)', fontSize: 13, fontWeight: 500,
              cursor: 'pointer',
            }}>
              Reintentar
            </button>
          </div>
        </div>
      </div>
    );
  }
}
